import i18n from "@/i18n/i18n";

export const LMS_IMPORT_SCENARIO_STEPS = {
  get classAssignmentSelect() {
    return {
      element: "[data-testid='lms-import-settings-form-class-assignment']",
      popover: {
        title: i18n.t("onboarding.lmsImport.classAssignment.title"),
        description: i18n.t("onboarding.lmsImport.classAssignment.description"),
        side: "top",
        align: "center",
      },
    };
  },
  get selectSubmissions() {
    return {
      element: "[data-testid='lms-import-submissions-form-select-submissions']",
      popover: {
        title: i18n.t("onboarding.lmsImport.selectSubmissions.title"),
        description: i18n.t(
          "onboarding.lmsImport.selectSubmissions.description"
        ),
        side: "top",
        align: "center",
      },
    };
  },
};

export default {
  get steps() {
    return [
      LMS_IMPORT_SCENARIO_STEPS.classAssignmentSelect,
      LMS_IMPORT_SCENARIO_STEPS.selectSubmissions,
    ];
  },
};
